export default __webpack_public_path__ + "static/media/feather _ chevron-right.547ba3d9.svg";